import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Alert, Intent } from '@blueprintjs/core';
import * as DataList from 'components/DataList';
import Toast from 'helpers/toaster';
import DefaultItem from './DefaultItem';

// Layout shared by the list and its loading skeleton (pages/preferences/line_items.js).
export const LINE_ITEM_COLUMNS = [
  { area: 'description', label: 'Description', width: 'minmax(200px, 1.6fr)', bone: 'single' },
  { area: 'type', label: 'Type', width: 'minmax(200px, 1.2fr)', bone: 'single' },
  { area: 'value', label: 'Value', width: 'minmax(110px, 0.6fr)', bone: 'short' },
  { area: 'actions', label: '', width: '120px', bone: 'none' },
];

export const LINE_ITEM_CARDS = {
  columns: 'minmax(0, 1fr) auto',
  areas: ['description description', 'type type', 'value actions'],
};

export const LINE_ITEM_MIN_TABLE_WIDTH = 640;

// Settings > Default line items: one editable row per item; delete asks first.
@inject('preferenceStore') @observer
class DefaultLineItemsList extends Component {
  @observable deleting = null; // the line item waiting for delete confirmation

  confirmDelete = () => {
    const lineItem = this.deleting;
    this.deleting = null;
    this.props.preferenceStore.deleteDefaultLineItem(lineItem)
      .then(() => {
        Toast.show({ message: 'Line item deleted.', intent: Intent.SUCCESS });
      })
      .catch((error) => {
        const reason = error && error.response && error.response.data && error.response.data.errors;
        Toast.show({ message: reason || "Couldn't delete the line item. Try again.", intent: Intent.DANGER });
      });
  };

  render() {
    const { items, onAdd } = this.props;
    if (!items || items.length === 0) {
      return (
        <DataList.Empty
          noun="default line items"
          title="No default line items yet"
          message="Add a charge such as a percentage of materials or labor, or a set dollar amount."
          extraAction={onAdd && { label: 'Add line item', icon: 'add', onClick: onAdd, primary: true }}
        />
      );
    }
    const deleting = this.deleting;
    return (
      <div className="fd dli">
        <DataList.List
          columns={LINE_ITEM_COLUMNS}
          cards={LINE_ITEM_CARDS}
          minTableWidth={LINE_ITEM_MIN_TABLE_WIDTH}
          total={items.length}
          noun="default line items"
        >
          {items.map((lineItem) => (
            <DefaultItem key={lineItem.id} line_item={lineItem} onDelete={(item) => { this.deleting = item; }} />
          ))}
        </DataList.List>
        <Alert
          isOpen={Boolean(deleting)}
          icon="trash"
          intent={Intent.DANGER}
          cancelButtonText="Cancel"
          confirmButtonText="Delete line item"
          onCancel={() => { this.deleting = null; }}
          onConfirm={this.confirmDelete}
        >
          <strong>{deleting && deleting.description ? `Delete ${deleting.description}?` : 'Delete this line item?'}</strong>
          <p>It comes off your default line items.</p>
        </Alert>
      </div>
    );
  }
}

export default DefaultLineItemsList;
